/**
 * Runtime platform detection.
 *
 * Centralised so the rest of the SPA can ask "are we running inside the
 * Tauri desktop or mobile runtime?" without coupling to the Tauri runtime API.
 */

/**
 * True when the page is being served inside a Tauri WebView. Mirrors what
 * `@tauri-apps/api/core`'s `isTauri()` checks — we read the global directly
 * to avoid having to load the Tauri JS module just for a feature flag.
 */
export function isTauriRuntime(): boolean {
  return "__TAURI_INTERNALS__" in globalThis;
}
